import { useQuery } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

/**
 * 처방전 관리 — GET /prescription/list (status_counts + sort)
 * 목록 실시간 갱신은 MainLayout 폴링(orderStore)이 담당. 이 훅은 탭 개수(status_counts)와
 * '최신 방문 순' 정렬 목록용. refreshKey(orderStore.lastUpdate)가 바뀔 때 다시 조회.
 */
export const usePrescriptionList = (
  sort: 'received_at' | 'latest_visit',
  refreshKey: unknown,
) => {
  return useQuery({
    queryKey: ['prescription-list', sort, refreshKey],
    queryFn: async () => {
      // include_benefits: 환자 포인트·쿠폰(정산 서버 조회). 5초 폴링(MainLayout)에는 넣지 않는다
      const res = await getPrescriptionService().getOrderList({
        page: 1,
        size: 100,
        sort,
        include_benefits: true,
      });
      if (!isResultOk(res)) return null;
      return {
        items: res?.data?.items ?? [],
        statusCounts: res?.data?.status_counts ?? null,
      };
    },
    placeholderData: prev => prev,
  });
};
